import React from 'react';
import * as LucideIcons from 'lucide-react';
import { useTranslation } from 'react-i18next';

const DreamWeaveEvents = ({ quests, event, setActiveTab }) => {
    const { t } = useTranslation();

    return (
        <div className="p-4 text-white h-full overflow-y-auto">
            {/* Synaptic Overload Event */}
            {event?.synapticOverload?.isActive && (
                <div className="mb-4 p-4 bg-red-900/80 border border-red-500 rounded-lg shadow-lg">
                    <div className="flex items-center mb-2">
                        <LucideIcons.AlertTriangle className="w-6 h-6 text-red-400 mr-3" />
                        <h3 className="text-lg font-bold text-red-300">{t('dreamWeaveEvents.synapticOverload.title')}</h3>
                    </div>
                    <p className="text-sm text-red-200">
                        {t('dreamWeaveEvents.synapticOverload.description', { theme: event.synapticOverload.theme, counterTheme: event.synapticOverload.counterTheme })}
                    </p>
                </div>
            )}

            {/* Dream Quests */}
            <div className="p-4 bg-gray-900/80 border border-gray-600 rounded-lg shadow-lg">
                <div className="flex items-center mb-3">
                    <LucideIcons.Target className="w-6 h-6 text-indigo-400 mr-3" />
                    <h3 className="text-lg font-bold text-indigo-300">{t('dreamWeaveEvents.dreamQuests.title')}</h3>
                </div>
                {quests && quests.length > 0 ? (
                    <div className="space-y-3">
                        {quests.map(quest => (
                            <div key={quest.id} className="p-3 bg-gray-700/70 rounded-md">
                                <p className="text-sm font-semibold text-gray-200">{quest.title}</p>
                                <p className="text-xs text-gray-400 mb-2">{quest.description}</p>
                                <button 
                                    onClick={() => setActiveTab('contribute')}
                                    className="text-xs mt-1 text-indigo-400 hover:underline font-bold"
                                >
                                    {t('dreamWeaveEvents.dreamQuests.goToContributionHub')}
                                </button>
                            </div>
                        ))}
                    </div>
                ) : (
                    <div className="text-center py-4">
                        <LucideIcons.MoonStar size={32} className="mx-auto text-gray-500 mb-2" />
                        <p className="text-sm text-gray-400 italic">{t('dreamWeaveEvents.dreamQuests.noQuests.title')}</p>
                        <p className="text-xs text-gray-500">{t('dreamWeaveEvents.dreamQuests.noQuests.subtitle')}</p>
                    </div>
                )}
            </div>
        </div>
    );
};

export default DreamWeaveEvents;
